module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABVSURBVHgBndDRCQAgCARQR2iERmnzRmmUi0AhIlEvCPy4e4ICYOnvQrzTM0N0AANeEAzrDOj2qmCYz4LpxVGwfBKvAPK2v+KgIAcEDTngpKEHbZncBomeNkhngzNhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_old/arrow_down.png
// module id = 1908
// module chunks = 8